import { Component } from "react"
import PropTypes from "prop-types"
import { ListSubheader, TextField, InputAdornment } from "@mui/material"
import { Search } from "@mui/icons-material"

class ColumnSearch extends Component {
  static propTypes = {
    searchColumn: PropTypes.func.isRequired,
    type: PropTypes.string.isRequired,
    value: PropTypes.string,
  }

  static defaultProps = {
    value: "",
  }

  search = ev => {
    const { searchColumn, type } = this.props
    searchColumn(type, ev.target.value)
  }

  render() {
    const { value } = this.props

    return <ListSubheader className="column-search-wrapper">
      <TextField
        variant="standard"
        fullWidth
        placeholder="Search"
        value={value}
        onChange={this.search}
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position="start">
                <Search />
              </InputAdornment>
            ),
          },
        }}
      />
    </ListSubheader>
  }
}

export default ColumnSearch
